import { Contract } from "../../entity/Contract";
import { toDate } from "../../utils/GlobalFunctions";
import { ContractDto } from "../dto/Contract.Dto";

export const mapContractDtoToContract = (
  contractDto: ContractDto[],
): Contract[] => {
  return contractDto.map((contract) => {
    return {
      id: contract.id,
      userId: contract.userId,
      storeId: contract.storeId,
      plan: contract.plan,
      contractType: contract.contractType,
      status: contract.status,
      paymentMethod: contract.paymentMethod,
      startDate: contract.startDate,
      endDate: contract.endDate,
      salary: contract.salary,
      createdAt: toDate(contract.createdAt),
      updatedAt: toDate(contract.updatedAt),
    };
  });
};
